'use client';

import { useState } from 'react';

type FAQ = { q: string; a: string };

export function ContactFAQ({ faqs }: { faqs: FAQ[] }) {
  const [open, setOpen] = useState<number | null>(null);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
      <style>{`
        .faq-answer { padding: 0 24px 20px 68px; font-size: 0.9rem; color: rgba(26,10,30,0.55); line-height: 1.75; margin: 0; }
        @media (max-width: 480px) {
          .faq-answer { padding: 0 16px 16px 16px; }
        }
      `}</style>
      {faqs.map((f, i) => {
        const isOpen = open === i;
        return (
          <div
            key={i}
            style={{
              background: isOpen ? 'rgba(254,122,168,0.06)' : '#fff',
              border: isOpen
                ? '1.5px solid rgba(254,122,168,0.4)'
                : '1.5px solid rgba(26,10,30,0.08)',
              borderRadius: '16px',
              overflow: 'hidden',
              transition: 'border-color 0.2s, background 0.2s',
            }}
          >
            <button
              onClick={() => setOpen(isOpen ? null : i)}
              aria-expanded={isOpen}
              style={{
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
                padding: '20px 24px',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                textAlign: 'left',
                fontFamily: 'inherit',
              }}
            >
              <span
                style={{
                  flexShrink: 0,
                  width: '28px',
                  height: '28px',
                  borderRadius: '50%',
                  background: isOpen ? '#fe7aa8' : 'rgba(254,122,168,0.12)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '0.7rem',
                  fontWeight: 800,
                  color: isOpen ? '#fff' : '#fe7aa8',
                  transition: 'background 0.2s, color 0.2s',
                }}
              >
                {String(i + 1).padStart(2, '0')}
              </span>
              <span
                style={{
                  flex: 1,
                  fontSize: '0.97rem',
                  fontWeight: 700,
                  color: '#1a0a1e',
                  lineHeight: 1.4,
                }}
              >
                {f.q}
              </span>
              <span
                style={{
                  flexShrink: 0,
                  width: '24px',
                  height: '24px',
                  borderRadius: '50%',
                  border: '1.5px solid rgba(26,10,30,0.15)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '1rem',
                  color: 'rgba(26,10,30,0.4)',
                  transform: isOpen ? 'rotate(45deg)' : 'rotate(0deg)',
                  transition: 'transform 0.25s',
                }}
                aria-hidden="true"
              >
                +
              </span>
            </button>
            <div
              style={{
                maxHeight: isOpen ? '500px' : '0',
                overflow: 'hidden',
                transition: 'max-height 0.3s ease',
              }}
            >
              <p className="faq-answer">
                {f.a}
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
}
